import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { UserProvider } from '../hooks/useUser';
import { commonRoutes } from '../commonPages/CommonRoutes';
import Layout from './components/Layout';
import Homepage from './pages/Homepage';
import SettingsPage from './pages/SettingsPage';
import { RheaThemeProvider } from './theme/RheaThemeProvider';
import { Helmet } from 'react-helmet';
import ChatPage from './pages/Chat';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { LocationProvider } from './contexts/LocationContext';
import SearchEngine from './pages/SearchEngine';
import Vision from './pages/Vision';

const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};

const RheaIndex = () => {
  return (
    <UserProvider mountingScreen={<></>}>
      <Helmet>
          <meta name="description" content="Rhea: AI Product Development, Agentic Search, Domain Search" />
          <meta name="keywords" content="Rhea, AI, Product Development, Search, Agentic Search" />
          <title>Rhea</title>
          <link rel="icon" href="/assets/rhea/logo.png" />
      </Helmet>
      <RheaThemeProvider>
        <LocationProvider>
          <WebSocketProvider>
            <Router>
              <Layout>
                <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/" element={<ExternalRedirect to="https://thoughtful-oasis.com" />} />
                <Route path="/search/:conversationId?" element={<SearchEngine />} />
                <Route path="/chat/:conversationId" element={<ChatPage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/easter-egg" element={<Vision />} />
                {commonRoutes}
                {/* Fallback route */}
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/nl" element={<Navigate to="/chat/new?agent=rhea_domain" replace />} />
                <Route path="*" element={<ExternalRedirect to="https://thoughtful-oasis.com" />} />
              </Routes>
              </Layout>
            </Router>
          </WebSocketProvider>
        </LocationProvider>
      </RheaThemeProvider>
    </UserProvider>
  );
};

export default RheaIndex;